import { render, staticRenderFns } from "./BodyText.vue?vue&type=template&id=786a6ad4&"
import script from "./BodyText.vue?vue&type=script&lang=js&"
export * from "./BodyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports